import AbstractResource from "@/resources/abstract/AbstractResource";
import AbstractApi from "@/services/api/AbstractApi";

export default class AbstractOnboardResource extends AbstractResource {
  constructor(api: AbstractApi) {
    super();
    this.api = api;
  }
}
